export default "__VITE_ASSET__z2Ud67CT__"